import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store'
import { ToastProvider } from './contexts/ToastContext'
import MainLayout from './components/Layout/MainLayout'
import Dashboard from './components/Dashboard'
import WebsiteConfigList from './pages/WebsiteConfigList'
import CouponTrigger from './pages/CouponTrigger'
import PhoneGroupList from './pages/PhoneGroupList'
import AlgorithmTest from './pages/AlgorithmTest'
import Login from './pages/Login'
import { isLoggedIn } from './utils/auth'

// 保护路由组件
const PrivateRoute = ({ children }) => {
  const isAuthenticated = isLoggedIn()
  return isAuthenticated ? children : <Navigate to="/login" />
}

// 主布局路由组件
const LayoutRoutes = () => {
  return (
    <MainLayout>
      <Routes>
        <Route path="/website-config" element={<WebsiteConfigList />} />
        <Route path="/coupon-trigger" element={<CouponTrigger />} />
        <Route path="/phone-groups" element={<PhoneGroupList />} />
        <Route path="/algorithm-test" element={<AlgorithmTest />} />
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </MainLayout>
  )
}

function App() {
  return (
    <Provider store={store}>
      <ToastProvider>
        <Router>
          <Routes>
            {/* 登录页面路由 */}
            <Route path="/login" element={<Login />} />
            
            {/* 需要主布局的路由 */}
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <LayoutRoutes />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ToastProvider>
    </Provider>
  )
}

export default App
